import { History } from 'lucide-react'

import { rubricSectionHighlight } from '@/components/admin/evaluation-rubrics/rubric-section-ids'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { EntityManageSection } from '@/components/ui/entity-manage-section'
import type { RubricRevisionSummary } from '@/hooks/use-evaluation-rubrics-admin'

type RubricRevisionHistorySectionProps = {
  revisions: RubricRevisionSummary[]
  highlighted?: boolean
  onViewAll: () => void
  defaultOpen?: boolean
}

export function RubricRevisionHistorySection({
  revisions,
  highlighted,
  onViewAll,
  defaultOpen = true,
}: RubricRevisionHistorySectionProps) {
  const recent = revisions.slice(0, 3)

  return (
    <div id={rubricSectionHighlight('history')}>
      <EntityManageSection
        title="Revision history"
        subtitle="Published rubric versions"
        leadingIcon={History}
        onEdit={revisions.length > 0 ? onViewAll : undefined}
        editAriaLabel="View all revisions"
        editTitle="View all revisions"
        highlighted={highlighted}
        agentHighlight={rubricSectionHighlight('history')}
        collapsible
        defaultOpen={defaultOpen}
      >
        {recent.length === 0 ? (
          <p className="text-sm text-muted-foreground">No revisions yet.</p>
        ) : (
          <div className="space-y-3">
            <ul className="space-y-2 text-sm">
              {recent.map((revision) => (
                <li key={revision.id} className="flex flex-wrap items-center gap-2">
                  <span className="font-medium">v{revision.version}</span>
                  <Badge variant="outline">{revision.provenance}</Badge>
                  <span className="text-muted-foreground">
                    {new Date(revision.created_at).toLocaleString()}
                  </span>
                </li>
              ))}
            </ul>
            {revisions.length > 3 ? (
              <Button type="button" variant="outline" size="sm" onClick={onViewAll}>
                View all {revisions.length} revisions
              </Button>
            ) : null}
          </div>
        )}
      </EntityManageSection>
    </div>
  )
}
